module.exports = __webpack_public_path__ + "images/emoji/fist.1d940f3645937a751fb9.png";